export const LOADER_STATUS = 'boilderplate/FileGSTR7/LOADER_STATUS';
export const PROFILE_DATA = 'boilderplate/FileGSTR7/PROFILE_DATA';
export const SET_ENTITY_LIST = 'boilderplate/Summary/SET_ENTITY_LIST';